<template>
  <v-container
    fluid
    class="pa-0 pa-md-6"
    style="background-color: #0f0f0f; min-height: 100vh"
  >
    <v-row justify="center" class="ma-0">
      <v-col cols="12" md="10" lg="7" class="pa-0 pa-md-3">
        <div class="d-flex align-center mb-4 mb-md-8 px-4 py-4 sticky-header">
          <v-btn icon dark @click="$router.back()" class="mr-2">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div class="flex-grow-1 overflow-hidden">
            <h1
              class="text-h6 text-md-h5 white--text font-weight-black text-truncate"
            >
              {{ categoria.nombre || "Cargando..." }}
            </h1>
            <div class="d-flex align-center">
              <v-progress-linear
                :value="(productosContados / productos.length) * 100"
                color="green"
                height="6"
                rounded
                class="mr-3"
                style="max-width: 100px"
              ></v-progress-linear>
              <span
                class="grey--text text-caption font-weight-bold uppercase-bold"
              >
                {{ productosContados }}/{{ productos.length }}
              </span>
            </div>
          </div>
        </div>

        <div class="px-3 pb-10">
          <v-card
            v-for="prod in productos"
            :key="prod.id"
            :class="{ 'item-completado': prod.completado }"
            class="mb-3 rounded-lg border-subtle bg-dark-refined item-auditoria"
            flat
          >
            <v-card-text class="pa-4">
              <v-row align="center" no-gutters>
                <!-- Número de línea: el mismo de la hoja de conteo impresa -->
                <v-col cols="auto" class="mr-3 linea-conteo grey--text font-weight-black text-body-2">
                  {{ prod.linea }}
                </v-col>

                <!-- Check icon -->
                <v-col cols="auto" class="mr-3">
                  <v-icon v-if="prod.completado" color="green">mdi-check-circle</v-icon>
                  <v-icon v-else color="#333">mdi-circle-outline</v-icon>
                </v-col>

                <!-- Imagen -->
                <v-col v-if="prod.imagen" cols="auto" class="mr-3">
                  <v-img
                    :src="prod.imagen"
                    width="40"
                    height="40"
                    class="rounded"
                    contain
                  ></v-img>
                </v-col>

                <!-- Nombre + subtítulo -->
                <v-col
                  class="overflow-hidden"
                  @click="abrirModal(prod)"
                  style="cursor: pointer"
                >
                  <div class="white--text font-weight-bold text-body-1 text-truncate">
                    {{ prod.nombre }}
                  </div>
                  <div class="d-flex align-center flex-wrap mt-1" style="gap: 4px;">
                    <span v-if="prod.completado" class="green--text text-caption font-weight-black">
                      {{ prod.cantidadFisica }} contados
                    </span>
                    <span v-else class="grey--text text-caption">Sin contar</span>
                    <v-chip
                      v-if="prod.tipo_stock === 'BASE'"
                      x-small
                      color="amber darken-3"
                      text-color="white"
                      class="font-weight-bold px-1"
                      style="height: 16px; font-size: 9px; letter-spacing: 0.5px;"
                    >
                      <v-icon style="font-size: 9px;" left>mdi-alert</v-icon>
                      UNIDAD BASE
                    </v-chip>
                    <v-chip
                      v-if="prod.tipo_stock === 'TRANSF'"
                      x-small
                      color="#2a2a2a"
                      text-color="grey"
                      class="font-weight-bold px-1"
                      style="height: 16px; font-size: 9px; letter-spacing: 0.5px;"
                    >
                      TRANSFORMACIÓN
                    </v-chip>
                  </div>
                </v-col>

                <v-col cols="auto" class="text-center px-4">
                  <div
                    class="grey--text text-overline mb-n1"
                    style="font-size: 8px !important"
                  >
                    SIST
                  </div>
                  <div class="white--text font-weight-black text-body-1">
                    {{ prod.cantidadVirtual }}
                  </div>
                </v-col>

                <v-col cols="auto">
                  <v-switch
                    v-model="prod.completado"
                    :loading="loadingSwitchId === prod.id"
                    :disabled="loadingSwitchId === prod.id"
                    color="green"
                    class="ma-0 pa-0"
                    hide-details
                    @change="setCompletado(prod)"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>

        <v-dialog
          v-model="modalProducto"
          :fullscreen="$vuetify.breakpoint.xsOnly"
          max-width="450"
          transition="dialog-bottom-transition"
        >
          <v-card
            v-if="productoActual"
            class="d-flex flex-column rounded-t-xl rounded-md-xl"
            color="#161616"
            dark
          >
            <v-toolbar flat color="transparent" class="hidden-sm-and-up">
              <v-btn icon @click="modalProducto = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-toolbar-title class="text-body-1 font-weight-bold"
                >Ajustar cantidad</v-toolbar-title
              >
            </v-toolbar>

            <div
              class="pa-6 pt-2 flex-grow-1 d-flex flex-column justify-center"
            >
              <div class="text-center mb-4">
                <v-img
                  v-if="productoActual.imagen"
                  :src="productoActual.imagen"
                  max-width="100"
                  max-height="100"
                  class="rounded-lg mx-auto mb-3"
                  contain
                ></v-img>
                <div class="white--text text-h5 font-weight-black mb-2">
                  {{ productoActual.nombre }}
                </div>
                <v-chip small outline color="grey"
                  >SKU: {{ productoActual.id }}</v-chip
                >
              </div>

              <v-alert
                v-if="productoActual.tipo_stock === 'BASE'"
                color="amber darken-3"
                dense
                text
                class="mb-4 rounded-lg text-caption font-weight-bold"
                icon="mdi-alert-outline"
              >
                Ingresá el total en <strong>unidad base</strong>. No cuentes cajas ni paquetes — solo unidades individuales.
              </v-alert>

              <div class="d-flex align-center justify-center mb-6">
                <v-btn
                  fab
                  large
                  depressed
                  color="#222"
                  @click="productoActual.cantidadFisica--"
                >
                  <v-icon size="24">mdi-minus</v-icon>
                </v-btn>
                <div class="mx-6 text-center" style="width: 120px">
                  <input
                    v-model.number="productoActual.cantidadFisica"
                    type="number"
                    class="input-huge"
                  />
                  <div class="grey--text text-caption font-weight-bold mt-1">
                    FÍSICA
                  </div>
                </div>
                <v-btn
                  fab
                  large
                  depressed
                  color="white"
                  class="black--text"
                  @click="productoActual.cantidadFisica++"
                >
                  <v-icon size="24">mdi-plus</v-icon>
                </v-btn>
              </div>

              <v-divider class="my-4" color="#333" />
              <v-row class="text-center">
                <v-col cols="6">
                  <div class="grey--text text-overline">Sistema</div>
                  <div class="white--text font-weight-black">
                    {{ productoActual.cantidadVirtual }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="grey--text text-overline">Movida</div>
                  <div
                    :class="
                      cantidadMovida !== 0 ? 'orange--text' : 'grey--text'
                    "
                    class="font-weight-black"
                  >
                    {{ cantidadMovida > 0 ? "+" : "" }}{{ cantidadMovida }}
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-card-actions class="pa-6">
              <v-btn
                block
                x-large
                color="white"
                class="black--text font-weight-black rounded-pill py-6"
                @click="guardarCantidad"
              >
                CONFIRMAR Y GUARDAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InventarioAPI from "@/api/inventario";

export default {
  name: "SucursalProductosInventarioCategoria",
  data() {
    return {
      categoria: { nombre: "" },
      productos: [],
      modalProducto: false,
      productoActual: null,
      loadingSwitchId: null,
    };
  },
  computed: {
    productosContados() {
      return this.productos.filter((p) => p.completado).length;
    },
    cantidadMovida() {
      if (!this.productoActual) return 0;
      const fisica =
        this.productoActual.cantidadFisica ??
        this.productoActual.cantidadVirtual;
      return fisica - this.productoActual.cantidadVirtual;
    },
  },
  created() {
    this.getProductosCategoria();
  },
  methods: {
    async getProductosCategoria() {
      const { inventarioUuid, categoriaId } = this.$route.params;
      try {
        const { data } = await InventarioAPI.getProductosCategoria(
          inventarioUuid,
          categoriaId
        );
        this.categoria = data.categoria;
        this.productos = data.productos;
      } catch (e) {
        console.error("Error al obtener productos:", e);
      }
    },

    abrirModal(producto) {
      this.productoActual = { ...producto };
      this.modalProducto = true;
    },

    async setCompletado(producto) {
      if (!producto) return;
      if (producto.cantidadFisica == null)
        producto.cantidadFisica = producto.cantidadVirtual;
      this.loadingSwitchId = producto.id;
      await this._guardarCambio(producto);
    },

    async guardarCantidad() {
      if (!this.productoActual) return;
      this.productoActual.completado = true;
      await this._guardarCambio(this.productoActual);
      this.modalProducto = false;
    },

    async _guardarCambio(producto) {
      const inventarioUuid = this.$route.params.inventarioUuid;
      const payload = {
        cantidad_fisica: producto.cantidadFisica,
        completado: producto.completado,
      };

      try {
        const { data } = await InventarioAPI.updateDetalle(
          inventarioUuid,
          producto.id,
          payload
        );
        const index = this.productos.findIndex((p) => p.id === data.id);
        if (index !== -1) this.$set(this.productos, index, { ...this.productos[index], ...data });

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "success",
          text: "Actualizado",
          timeout: 2500,
        });
      } catch (e) {
        producto.completado = !producto.completado;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "Error al actualizar",
          timeout: 2500,
        });
      } finally {
        this.loadingSwitchId = null;
      }
    },
  },
};
</script>

<style scoped>
.linea-conteo {
  min-width: 24px;
  text-align: right;
}
.bg-dark-refined {
  background-color: #161616 !important;
}
.border-subtle {
  border: 1px solid #222 !important;
}
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: rgba(15, 15, 15, 0.9);
  backdrop-filter: blur(10px);
}
.item-completado {
  border-left: 4px solid #4caf50 !important;
  background-color: rgba(76, 175, 80, 0.05) !important;
}
.input-huge {
  background: transparent;
  border: none;
  color: white;
  font-size: 4rem;
  font-weight: 900;
  width: 100%;
  text-align: center;
  outline: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.uppercase-bold {
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 10px !important;
}
</style>